import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Packages
import onClickOutside from 'react-onclickoutside';

// Actions
import {
  hideModal,
} from '../../actions/modal';

class ModalContainer extends Component {

  static propTypes = {
    closeOnClickOutside: PropTypes.bool,
    modalExit: PropTypes.bool,
    optionalClasses: PropTypes.string,
    title: PropTypes.string,
  }

  handleClickOutside = () => {
    const { closeOnClickOutside } = this.props;

    if (closeOnClickOutside) {
      this.props.hideModal();
    }
  }

  closeModal = (event) => {
    event.preventDefault();
    this.props.hideModal();
  }

  renderModalHeader(title) {
    return title ? (
      <header>
        <h1 className="modal-heading">{title}</h1>
      </header>
    )
    : ''
  }

  renderOptionalModalExit = () => {
    const { modalExit } = this.props;
    let modalExitStatus = modalExit === true || modalExit === false  ? modalExit : true;

    return modalExitStatus
    ? (
      <a
        className="modal-container-close"
        onClick={(event) => this.closeModal(event)}
      >
        <svg className="icon">
          <use xlinkHref="#close"/>
        </svg>
      </a>
    ) : '';
  }

  render() {
    let { children, title, optionalClasses } = this.props;

    return(
      <div className={`modal-container${optionalClasses ? ' ' + optionalClasses : ''}`}>
        {this.renderOptionalModalExit()}
        <div className="modal-container-inner">
          {this.renderModalHeader(title)}
          {children}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    },
  }
}

ModalContainer = onClickOutside(ModalContainer);
ModalContainer = connect(mapStateToProps, mapDispatchToProps)(ModalContainer);

export default ModalContainer


// WEBPACK FOOTER //
// ./src/components/Modals/ModalContainer.js